"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var input_button_1 = __importDefault(require("@components/input-button"));
var panel_1 = __importDefault(require("@components/panel"));
var countriesDropdown_1 = require("../configs/countriesDropdown");
var style_1 = require("./style");
var CountryDropdown = function (_a) {
    var flagCode = _a.flagCode;
    var countryDropdownRef = react_1.useRef(null);
    var _b = react_1.useState(false), isPanelOpen = _b[0], setIsPanelOpen = _b[1];
    /*
    ** Detect clicks outside in order to close the panel
    */
    react_1.useEffect(function () {
        var listener = function (e) {
            var _a, _b;
            if (countryDropdownRef.current !== null &&
                !((_b = (_a = countryDropdownRef.current) === null || _a === void 0 ? void 0 : _a.contains) === null || _b === void 0 ? void 0 : _b.call(_a, e.target))) {
                setIsPanelOpen(false);
            }
        };
        document.addEventListener('mousedown', listener);
        document.addEventListener('touchstart', listener);
        return function () {
            document.removeEventListener('mousedown', listener);
            document.removeEventListener('touchstart', listener);
        };
    }, [countryDropdownRef, setIsPanelOpen]);
    var countyConfig = countriesDropdown_1.COUNTRIES_CONFIG.find(function (config) { return config.flagCode === flagCode; });
    var _c = countyConfig, CountryFlag = _c.flag, countryLabel = _c.label;
    return (react_1.default.createElement(style_1.Wrapper, { ref: countryDropdownRef },
        react_1.default.createElement(input_button_1.default, { className: 'CountryDropdown__select', isActive: isPanelOpen, isControlled: false, onInputClick: function () { return setIsPanelOpen(!isPanelOpen); }, rightActiveIconVariant: 'arrow-up', rightInactiveIconVariant: 'arrow-down' },
            react_1.default.createElement("div", { className: 'CountryDropdown__selected' },
                react_1.default.createElement(CountryFlag, { className: 'CountryDropdown__flag' }),
                react_1.default.createElement("div", { className: 'CountryDropdown__selectedText' },
                    react_1.default.createElement("div", { className: 'CountryDropdown__selectedMessage' }, "Select a country"),
                    react_1.default.createElement("div", { className: 'CountryDropdown__selectedCountry' }, countryLabel)))),
        isPanelOpen ? (react_1.default.createElement(panel_1.default, { shouldFitToContainer: true, className: 'CountryDropdown__panel' },
            react_1.default.createElement("ul", { className: 'CountryDropdown__list' }, countriesDropdown_1.COUNTRIES_CONFIG.map(function (_a) {
                var Flag = _a.flag, href = _a.href, label = _a.label;
                return (react_1.default.createElement("li", { className: 'CountryDropdown__item', key: label },
                    react_1.default.createElement("a", { className: 'CountryDropdown__link', href: href },
                        react_1.default.createElement(Flag, { className: 'CountryDropdown__flag' }),
                        label)));
            })))) : null));
};
exports.default = CountryDropdown;
